import PublicLayout from "../components/PublicLayout";
import { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Preencha todos os campos obrigatórios"); return; }
    toast.success("Mensagem enviada! Retornaremos em breve.");
    setForm({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <PublicLayout>
      <div className="max-w-5xl mx-auto px-4 py-12" data-testid="contact-page">
        <div className="hairline-accent pt-3 mb-8">
          <h1 className="font-serif-display text-5xl font-bold">Fale Conosco</h1>
          <p className="font-body text-zinc-600 mt-2 text-lg">Dúvidas, sugestões de pauta ou denúncias: estamos ouvindo.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <form onSubmit={submit} className="border border-zinc-300 p-6 space-y-4" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="overline">Nome *</label>
                  <input type="text" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 mt-1 font-sans-ui" data-testid="contact-name" />
                </div>
                <div>
                  <label className="overline">E-mail *</label>
                  <input type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 mt-1 font-sans-ui" data-testid="contact-email" />
                </div>
              </div>
              <div>
                <label className="overline">Assunto</label>
                <input type="text" value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 mt-1 font-sans-ui" data-testid="contact-subject" />
              </div>
              <div>
                <label className="overline">Mensagem *</label>
                <textarea required rows={6} value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 mt-1 font-sans-ui" data-testid="contact-message" />
              </div>
              <button type="submit" className="bg-black text-white px-8 py-3 font-sans-ui text-sm uppercase tracking-widest font-semibold hover:bg-red-700" data-testid="contact-submit">Enviar Mensagem</button>
            </form>
          </div>
          <div className="space-y-6">
            <div className="border border-zinc-300 p-6">
              <p className="overline mb-3">Redação</p>
              <p className="font-sans-ui text-sm flex items-start gap-2"><MapPin size={14} className="mt-1 flex-shrink-0"/>Rua das Palmeiras, 100<br/>Rio Branco - AC, Brasil</p>
              <p className="font-sans-ui text-sm flex items-center gap-2 mt-3"><Phone size={14}/>(68) 3000-0000</p>
              <p className="font-sans-ui text-sm flex items-center gap-2 mt-3"><Mail size={14}/>redacao@chiquinho.com.br</p>
            </div>
            <div className="border border-zinc-300 p-6">
              <p className="overline mb-3">Comercial</p>
              <p className="font-sans-ui text-sm flex items-center gap-2"><Mail size={14}/>comercial@chiquinho.com.br</p>
              <p className="font-sans-ui text-xs text-zinc-500 mt-3">Para anúncios e parcerias publicitárias.</p>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
